import { NextSeo } from 'next-seo'

import { GiftSubscriptionBuyPage } from 'src/components/GiftSubscription/GiftSubscriptionBuyPage'
import { HeadCanonicals } from 'src/components/_nextjs/HeadCanonicals'
import { config } from 'src/config'
import { fetchGiftSubscriptionPlans, fetchGiftSubscriptionPrices } from 'src/data/providers/fetchGiftSubscriptions'
import { Language } from 'src/enum/Language'

import type { GetStaticPaths, GetStaticProps } from 'next'
import type { SubscriptionPlan, SubscriptionPrice } from 'src/types/Subscription'

interface GiftSubscriptionsBuyNextPageProps {
  plans: SubscriptionPlan[]
  prices: SubscriptionPrice[]
}

const title = 'Das nachhaltige Kaffee-Geschenkabo'
const subtitleMeta = 'Verschenke Überraschungen im Abo – mit einzigartigen, direkt gehandelten Kaffees & Espressos'

export const GiftSubscriptionLandingBuy = ({ plans, prices }: GiftSubscriptionsBuyNextPageProps) => (
  <>
    <NextSeo
      title={title}
      titleTemplate={config.nextSeo.titleTemplate}
      description={subtitleMeta}
      openGraph={{
        type: 'website',
        title,
        site_name: config.nextSeo.openGraph.site_name,
        description: subtitleMeta,
        images: config.nextSeo.openGraph.images,
      }}
    />
    <HeadCanonicals de="/de/e/geschenkabo" />
    <GiftSubscriptionBuyPage plans={plans} prices={prices} title={title} />
  </>
)

const getStaticProps: GetStaticProps = async () => {
  const plans = await fetchGiftSubscriptionPlans()
  const prices = await fetchGiftSubscriptionPrices()

  return { props: { plans, prices } }
}

const getStaticPaths: GetStaticPaths = async () => {
  const path = {
    params: {
      lang: Language.de,
      id: 'geschenkabo',
    },
  }

  return {
    paths: [path],
    fallback: false,
  }
}

export { getStaticProps, getStaticPaths }

export default GiftSubscriptionLandingBuy
